import Utils from "common/utils";

export default class ListenerManager {
    constructor() {
        this.__listenerMap = {}
    }

    /**
     * Add a listener callback, with optional key. 
     * If key is null, then a key will be created and returned in the response
     * @param {function} cb 
     * @param {string|null} key 
     * @returns {string|null} Key if everything was successfull, else null
     */
    addListener(cb, key) {
        if (Utils.isNull(cb)) {
            return null
        }

        if (Utils.isNull(key)) {
            key = this.__generateKey()
        }

        this.__listenerMap[key] = cb
        return key
    }

    __generateKey() {
        return `${Utils.generateUUID()}`
    }

    /**
     * Remove a listener for a string.
     * @param {string} key 
     * @returns {boolean} 
     */
    removeListener(key) {
        if (Utils.isNull(key)) {
            return false
        }
        return delete this.__listenerMap[key]
    }

    /**
     * Get all the callbacks as a list.
     */
    getAllListeners() {
        if (Utils.isNull(this.__listenerMap)) {
            return []
        }
        var dataMap=this.__listenerMap
        var vals = Object.keys(this.__listenerMap).map(function(key) {
            return dataMap[key];
        });
        return vals;
    }

    /**
     * Return the number of listeners.
     * @returns {integer} 
     */
    length() {
        if (Utils.isNull(this.__listenerMap)) {
            return 0
        }
        return Object.keys(this.__listenerMap).length
    }
}


// WEBPACK FOOTER //
// ./src/manager/listenerManager.js